import { Controller } from "@hotwired/stimulus"

// Holds every button that submits the form — a draft included — while its
// dropzones are still uploading or hold a file whose upload failed, so a submit
// can never carry half a deposit.
export default class extends Controller {
  static targets = ["submit"]
  static values = { one: String, other: String, failed: String }

  connect() {
    this.pendingByZone = new Map()
    this.failedByZone = new Map()
    this.idleLabels = new Map(this.submitTargets.map((target) => [target, this.labelOf(target)]))
  }

  sync(event) {
    this.pendingByZone.set(event.target, event.detail.count)
    this.failedByZone.set(event.target, event.detail.failed)

    const pending = this.total(this.pendingByZone)
    const failed = this.total(this.failedByZone)

    this.submitTargets.forEach((target) => {
      target.disabled = pending > 0 || failed > 0
      this.setLabel(target, this.labelFor(target, pending, failed))
    })
  }

  total(counts) {
    return Array.from(counts.values()).reduce((sum, count) => sum + count, 0)
  }

  labelFor(target, pending, failed) {
    if (pending === 1) return this.oneValue
    if (pending > 1) return this.otherValue.replace("%{count}", pending)
    if (failed > 0) return this.failedValue

    return this.idleLabels.get(target)
  }

  labelOf(target) {
    return target.tagName === "INPUT" ? target.value : target.textContent
  }

  setLabel(target, text) {
    if (target.tagName === "INPUT") {
      target.value = text
    } else {
      target.textContent = text
    }
  }
}
